var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.disabled)?_c('a',{staticClass:"btn btn-block btn-success btn-xs align-bottom",attrs:{"href":_vm.url}},[_vm._v("Bulk Purchase")]):_vm._e()}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b7f1a66","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Assets/components/RegistrationCategories/Tickets/Utility/BulkPurchaseBtn.vue
// module id = 2464
// module chunks = 1